import { render, staticRenderFns } from "./BaseTableWithPermissionCheck.vue?vue&type=template&id=34426a39&scoped=true&"
import script from "./BaseTableWithPermissionCheck.vue?vue&type=script&lang=js&"
export * from "./BaseTableWithPermissionCheck.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableWithPermissionCheck.vue?vue&type=style&index=0&id=34426a39&prod&scoped=true&lang=css&"
import style1 from "./BaseTableWithPermissionCheck.vue?vue&type=style&index=1&id=34426a39&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34426a39",
  null
  
)

export default component.exports